export default __webpack_public_path__ + "media/images/colors_128-e2efec985676815af311020acce4b305.png";